<div class="result">
    <PlayerSmall profile={findPlayer(card.userId)} />

    <div class="answer text">
        ...{replaceText(card.text, players)}
    </div>

    <div class="voters">
        {#each card.voters as voter}
            <PlayerSmall profile={findPlayer(voter)} />
        {/each}
    </div> 
</div>

<style>
.result{
    font-size: 1em;
    border-radius: 50px;
    margin-top: 1em;
    color: #fff;    
    background: linear-gradient(0deg, var(--giga), var(--tera));
    box-shadow: 10px 10px 29px #d3801a;
    display: flex;
    flex-direction: row;
    align-items: center;
}
.answer{
    width: 100%;
    font-size: 1.5em;
    line-height: 1em;
    margin: 20px 0px;
}
.voters{
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
}
</style>

<script>
import PlayerSmall from "../../../components/player/Small.svelte"

import { host } from "../../../stores/host"

export let card
export let players

import { replaceText } from "../../../code/replaceText"

const findPlayer = id => $host.players.find( player => player.id === id )
</script>